import { render, staticRenderFns } from "./purchaseAndSale.vue?vue&type=template&id=35070018&scoped=true"
import script from "./purchaseAndSale.vue?vue&type=script&lang=js"
export * from "./purchaseAndSale.vue?vue&type=script&lang=js"
import style0 from "./purchaseAndSale.vue?vue&type=style&index=0&id=35070018&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35070018",
  null
  
)

export default component.exports